import { Link, useLocation } from 'react-router-dom';
import { BrandedLayout } from '@/components/BrandedLayout';

/**
 * Post-signup confirmation screen.
 *
 * The user lands here after submitting the sign-up form. The copy is
 * intentionally enumeration-safe: it works whether the email was new
 * (Supabase sent a verification link) OR already registered (Supabase
 * sent nothing). From the outside, both flows look the same — preventing
 * an attacker from probing whether an email is registered.
 *
 * SignUp passes `alreadyRegistered` in route state for client-side
 * telemetry / future warm-path UX, but the copy on this page does NOT
 * branch on it.
 */
export default function CheckEmail() {
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email;

  return (
    <BrandedLayout>
      <div className="container mx-auto py-12 px-4">
        <div className="mx-auto w-full max-w-md space-y-4 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">
            Check your email
          </h1>
          <p className="text-sm text-muted-foreground">
            If <span className="font-medium text-foreground">{email ?? 'that email'}</span>{' '}
            isn&rsquo;t already registered with PharmaSync, you&rsquo;ll
            receive a verification link in your inbox shortly. Click it to
            activate your account, then sign in.
          </p>
          <p className="text-xs text-muted-foreground">
            The link is valid for 24 hours. Check your spam folder if you don&apos;t
            see it. Already have an account? Sign in directly.
          </p>
          <div>
            <Link
              to="/auth/sign-in"
              className="inline-block rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </BrandedLayout>
  );
}
